import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { DragDropContext } from "react-beautiful-dnd";
import { Container } from "reactstrap";

import {
    AppAside,
} from "@coreui/react";

//Lazy load this
import { languageActions } from "../../../../../store/actions/system/language/language.action";
import Notifier from "../../../../../components/UI/Notifier/Notifier";
import { systemLabelActions } from "../../../../../store/actions/system/systemLabel/systemLabel.action";
import PlaceholderContent from "../../components/PlaceholderContent/PlaceholderContent";
import TemplateWrapper from "./TemplateWrapper";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import EditorSidebar from "../../../../components/editor/EditorSidebar/EditorSidebar";
import { templateHelper } from "../../helpers/templateHelper";
import { getKey } from "../../../../../helpers/UrlHelper";

class TemplateLayout extends React.Component {
    state = {
        sidebarOpen: true,
        asideOpen: true
    }
    loading = () => (
        <div className="animated fadeIn pt-1 text-center">Loading...</div>
    );
    componentDidMount() {
        const { dispatch, user, match } = this.props;
        if (user) {
            let eventId = null;
            let languageCode = null;
            if (window.location.search) {
                const params = new URLSearchParams(window.location.search);
                let unparsedEventId = params.get(getKey("eventId", params));
                if (unparsedEventId) eventId = parseInt(unparsedEventId)
                languageCode = params.get(getKey("languageCode", params));
              }
              if (user && !eventId) {
                eventId = user.eid === undefined ? user.token.eid : user.eid;
              }
              if (user && !languageCode) {
                languageCode = user.userLang === undefined ? user.token.userLang : user.userLang;
              }
              if (!languageCode) languageCode = "swe";
            dispatch(languageActions.getAllCodesByEvent(eventId));
            dispatch(templateActions.get(match.params.id));
            dispatch(cmsActions.setEnviroment(sourceTypes.TEMPLATE, true, eventId, languageCode));
            dispatch(systemLabelActions.getGroup(languageCode, "Template.Edit"));
        }
    }
    onDragEnd = result => {
        templateHelper.onDragEnd(result)
    }
    toggleEditor = (editor) => {
        this.setState({ [editor]: !this.state[editor] })
    }
    render() {
        const { alert, form, template } = this.props;
        return (
            <React.Fragment>
                {template && (
                    <DragDropContext
                        onDragUpdate={this.onDragStart}
                        onDragEnd={this.onDragEnd}
                    >
                        <div className="app">
                            <div className="app-body" style={{ marginTop: '0px' }} ></div>
                            <AppAside
                                className="editor-aside"
                                fixed
                                display="lg"
                                style={{ width: "320px" }}
                                className={this.state.asideOpen ? "aside-show" : "aside-hide"}
                            >
                                <Suspense fallback={this.loading()}>
                                    <div ref={r => this.asideEditorRef = r}>
                                        <EditorSidebar
                                            toggleConditionModal={this.toggleConditionModal}
                                        />
                                    </div>
                                </Suspense>
                            </AppAside>
                            <main className="not-inflicted" style={{ marginLeft: this.state.asideOpen ? "320px" : "0px" }}>
                                <div className="animated fadeIn">
                                    <Container fluid style={{ padding: '0px' }} >
                                        <Suspense fallback={this.loading()}>
                                            <TemplateWrapper
                                                sidebarRef={this.sidebarRef}
                                                asideEditorRef={this.asideEditorRef}
                                                editMode={true}>
                                                <PlaceholderContent />
                                            </TemplateWrapper>
                                        </Suspense>
                                    </Container>
                                </div>
                            </main>
                        </div>
                        {alert.type ? (
                            <Notifier message={alert.message} type={alert.type} />
                        ) : null}
                    </DragDropContext>
                )}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user,
        alert: state.alert,
        form: state.form,
        event: state.event,
        template: state.template
    };
}
export default connect(mapStateToProps)(TemplateLayout);
